// Form dropdown options for marriage license application

export const US_STATES = [
  { value: '', label: 'Select State' },
  { value: 'Unknown', label: 'Unknown' },
  { value: 'Other', label: 'Other (Non-US)' },
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
  { value: 'DC', label: 'District of Columbia' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'GU', label: 'Guam' },
  { value: 'MP', label: 'Northern Mariana Islands' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'VI', label: 'U.S. Virgin Islands' }
];

export const SUFFIX_OPTIONS = [
  { value: '', label: 'None' },
  { value: 'Jr.', label: 'Jr.' },
  { value: 'Sr.', label: 'Sr.' },
  { value: 'II', label: 'II' },
  { value: 'III', label: 'III' },
  { value: 'IV', label: 'IV' },
  { value: 'V', label: 'V' }
];

export const RACE_OPTIONS = [
  { value: '', label: 'Select Race' },
  { value: 'Asian', label: 'Asian' },
  { value: 'Black', label: 'Black' },
  { value: 'Creole', label: 'Creole' },
  { value: 'East Indian', label: 'East Indian' },
  { value: 'Filipino', label: 'Filipino' },
  { value: 'Hispanic', label: 'Hispanic' },
  { value: 'Latino', label: 'Latino' },
  { value: 'Middle Eastern', label: 'Middle Eastern' },
  { value: 'Native American', label: 'Native American' },
  { value: 'Other', label: 'Other' },
  { value: 'Pacific Islander', label: 'Pacific Islander' },
  { value: 'White', label: 'White' }
];

export const LOUISIANA_PARISHES = [
  { value: '', label: 'Select Parish' },
  { value: 'Acadia', label: 'Acadia' },
  { value: 'Allen', label: 'Allen' },
  { value: 'Ascension', label: 'Ascension' },
  { value: 'Assumption', label: 'Assumption' },
  { value: 'Avoyelles', label: 'Avoyelles' },
  { value: 'Beauregard', label: 'Beauregard' },
  { value: 'Bienville', label: 'Bienville' },
  { value: 'Bossier', label: 'Bossier' },
  { value: 'Caddo', label: 'Caddo' },
  { value: 'Calcasieu', label: 'Calcasieu' },
  { value: 'Caldwell', label: 'Caldwell' },
  { value: 'Cameron', label: 'Cameron' },
  { value: 'Catahoula', label: 'Catahoula' },
  { value: 'Claiborne', label: 'Claiborne' },
  { value: 'Concordia', label: 'Concordia' },
  { value: 'De Soto', label: 'De Soto' },
  { value: 'East Baton Rouge', label: 'East Baton Rouge' },
  { value: 'East Carroll', label: 'East Carroll' },
  { value: 'East Feliciana', label: 'East Feliciana' },
  { value: 'Evangeline', label: 'Evangeline' },
  { value: 'Franklin', label: 'Franklin' },
  { value: 'Grant', label: 'Grant' },
  { value: 'Iberia', label: 'Iberia' },
  { value: 'Iberville', label: 'Iberville' },
  { value: 'Jackson', label: 'Jackson' },
  { value: 'Jefferson', label: 'Jefferson' },
  { value: 'Jefferson Davis', label: 'Jefferson Davis' },
  { value: 'La Salle', label: 'La Salle' },
  { value: 'Lafayette', label: 'Lafayette' },
  { value: 'Lafourche', label: 'Lafourche' },
  { value: 'Lincoln', label: 'Lincoln' },
  { value: 'Livingston', label: 'Livingston' },
  { value: 'Madison', label: 'Madison' },
  { value: 'Morehouse', label: 'Morehouse' },
  { value: 'Natchitoches', label: 'Natchitoches' },
  { value: 'Orleans', label: 'Orleans' },
  { value: 'Ouachita', label: 'Ouachita' },
  { value: 'Plaquemines', label: 'Plaquemines' },
  { value: 'Pointe Coupee', label: 'Pointe Coupee' },
  { value: 'Rapides', label: 'Rapides' },
  { value: 'Red River', label: 'Red River' },
  { value: 'Richland', label: 'Richland' },
  { value: 'Sabine', label: 'Sabine' },
  { value: 'St. Bernard', label: 'St. Bernard' },
  { value: 'St. Charles', label: 'St. Charles' },
  { value: 'St. Helena', label: 'St. Helena' },
  { value: 'St. James', label: 'St. James' },
  { value: 'St. John the Baptist', label: 'St. John the Baptist' },
  { value: 'St. Landry', label: 'St. Landry' },
  { value: 'St. Martin', label: 'St. Martin' },
  { value: 'St. Mary', label: 'St. Mary' },
  { value: 'St. Tammany', label: 'St. Tammany' },
  { value: 'Tangipahoa', label: 'Tangipahoa' },
  { value: 'Tensas', label: 'Tensas' },
  { value: 'Terrebonne', label: 'Terrebonne' },
  { value: 'Union', label: 'Union' },
  { value: 'Vermilion', label: 'Vermilion' },
  { value: 'Vernon', label: 'Vernon' },
  { value: 'Washington', label: 'Washington' },
  { value: 'Webster', label: 'Webster' },
  { value: 'West Baton Rouge', label: 'West Baton Rouge' },
  { value: 'West Carroll', label: 'West Carroll' },
  { value: 'West Feliciana', label: 'West Feliciana' },
  { value: 'Winn', label: 'Winn' }
];

export const COUNTRIES = [
  { value: '', label: 'Select Country' },
  { value: 'Unknown', label: 'Unknown' },
  { value: 'Other', label: 'Other (Not listed)' },
  { value: 'US', label: 'United States' },
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AG', label: 'Antigua and Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BA', label: 'Bosnia and Herzegovina' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BR', label: 'Brazil' },
  { value: 'BN', label: 'Brunei' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'CV', label: 'Cabo Verde' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CA', label: 'Canada' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros' },
  { value: 'CG', label: 'Congo' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'CD', label: 'Democratic Republic of the Congo' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'SZ', label: 'Eswatini' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GR', label: 'Greece' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: 'Laos' },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libya' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia' },
  { value: 'MD', label: 'Moldova' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'KP', label: 'North Korea' },
  { value: 'MK', label: 'North Macedonia' },
  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PS', label: 'Palestine' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'QA', label: 'Qatar' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russia' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'KN', label: 'Saint Kitts and Nevis' },
  { value: 'LC', label: 'Saint Lucia' },
  { value: 'VC', label: 'Saint Vincent and the Grenadines' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'ST', label: 'Sao Tome and Principe' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'KR', label: 'South Korea' },
  { value: 'SS', label: 'South Sudan' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SD', label: 'Sudan' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syria' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'TG', label: 'Togo' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad and Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VA', label: 'Vatican City' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Vietnam' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' }
];

export const COUNTRY_OTHER = 'Other';

const LISTED_COUNTRY_CODES = new Set(
  COUNTRIES.map((o) => o.value).filter((v) => v && v !== 'Unknown' && v !== COUNTRY_OTHER)
);

export function isListedCountry(code) {
  return LISTED_COUNTRY_CODES.has(code);
}

export function countrySelectValue(stored) {
  if (!stored) return '';
  if (stored === 'Unknown') return 'Unknown';
  if (stored === COUNTRY_OTHER || !isListedCountry(stored)) return COUNTRY_OTHER;
  return stored;
}

export function countryNameInputValue(stored) {
  if (!stored || stored === COUNTRY_OTHER || stored === 'Unknown' || isListedCountry(stored)) return '';
  return stored;
}

export function countryFromSelect(selectValue, previousStored) {
  if (selectValue !== COUNTRY_OTHER) return selectValue;
  if (
    previousStored &&
    previousStored !== COUNTRY_OTHER &&
    previousStored !== 'Unknown' &&
    !isListedCountry(previousStored)
  ) {
    return previousStored;
  }
  return COUNTRY_OTHER;
}
